<template>
    <b-container>
        <b-row>
            <b-col>
                <app-company-broadcast-message-form />
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import CompanyBroadcastMessageForm from './CompanyBroadcastMessageForm/CompanyBroadcastMessageForm';
export default {
    components: {
        appCompanyBroadcastMessageForm: CompanyBroadcastMessageForm
    }
}
</script>